/* TODO: possibly, implement also cookies backend, but I don't think it's relevant
   for this project that doesn't aim to support MSIE 3.01 or some such */

class backend_localStorage {
 put(k,d) { localStorage[k] = d } // eslint-disable-line class-methods-use-this
 get(k) { return localStorage[k] } // eslint-disable-line class-methods-use-this
 has(k) { return localStorage[k]!==undefined } // eslint-disable-line class-methods-use-this
 reset() { localStorage.clear() } // eslint-disable-line class-methods-use-this
}

const PERSISTENCE = {
 backend: new backend_localStorage(),
 put1: function persistence_put1(key,data) {
  this.backend.put(key,data===undefined?undefined:JSON.stringify(data));
 },
 get1: function persistence_get1(key,dflt) {
  const rv = this.backend.get(key);
  if(rv===undefined) return dflt;
  return JSON.parse(rv);
 },
 has1: function persistence_has1(key) {
  return this.backend.has(key);
 },

 put: function persistence_put(key,data) {
  if(key instanceof Array) {
   key.forEach(x=>this.put(x.key,x.data));
  }else if(key instanceof Object) {
   for(var k in key) this.put(k,key[k]);
  }else{
   this.put1(key,data);
  }
  return this;
 },
 get: function persistence_get(key,dflt) {
  if(key instanceof Array)
   throw new Error("I will implement this later, but don't yet know which way, so you should not be using array persistence get for now");
  if(key instanceof Object)
   return Object.keys(key).reduce((p,c)=>{
    p[c] = this.get(c,key[c]);
    return p;
   },{});
  return this.get1(key,dflt);
 },
 has: function persistence_has(key) {
  return this.has1(key);
 },
 reset: function persistence_reset() {
  return this.backend.reset();
 },
 namespace: function persistence_namespace(ns) {
  function k(key) {
   return ns+'.'+key;
  }
  var rv = {
   parent: this,
   root: this.root,
   put1: function namespaced_put1(key,data) { return this.parent.put1(k(key),data) },
   get1: function namespaced_get1(key,dflt) { return this.parent.get1(k(key),dflt) },
   has1: function namespaced_has1(key) { return this.parent.has1(k(key)) }
  };
  return Object.assign(rv,{
   put: this.put.bind(rv),
   get: this.get.bind(rv),
   has: this.has.bind(rv),
   namespace: this.namespace.bind(rv),
   reset: function namespaced_reset() {
    throw new Error("not implemented");
   }
  });
 }
};
PERSISTENCE.root = PERSISTENCE;

const app_namespace = window.location.pathname.replace(/^\/+/,'').replace(/\/+$/,'').replace(/\W+/g,'_');

export default PERSISTENCE.namespace(app_namespace);
